
import React from 'react';
import styled from 'styled-components';
import {
  Navbar,
} from 'react-bootstrap';
import i18n from '../../../config/i18n';
import logo from '../../../styles/images/logo.png';

const BrandText = styled.span`
  font-family: "Open Sans", Arial, sans-serif;
  color: #ffffff;
  font-size: 20px;
  font-weight: 700;
`;

const Logo = styled.img`
  width: 72px;
  margin-right: 15px;
  background-size: contain !important;

  @media screen and (max-width: 768px) {
    width: 60px;
    margin-top: -4px !important;
  }
`;

const StyledWrap = styled(Navbar.Brand)`
  margin: 0 15px !important;
  padding: 15px 0 !important;
  height: 50px !important;
`;

const StyledBrand = () => (
  <StyledWrap>
    <a href="/">
      <span><Logo src={logo} /></span>
      <BrandText>
        {i18n.t('iHealthCareClouds')}
      </BrandText>
    </a>
  </StyledWrap>
);

export default StyledBrand;



// WEBPACK FOOTER //
// ./src/components/shared/Nav/StyledBrand.js